<style scoped>
    @import url("../../../styles/smartControl/formDate.scss");
</style>

<template>
    <div class="box_formDate">

        <div class="menuForm">

            <div class="linhaForm">
                <span class="tLinha">Data de início da fase:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.dt_str_init"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="01/01/2001"
                        @change="prepareAndReturn()"
                    />
                    <!-- :placeholder="formLocal.minutos" -->
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Hora de início da fase:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.hhmm_init"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="00:01"
                        @change="prepareAndReturn()"
                    />
                    <!-- :placeholder="formLocal.minutos" -->
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Data de fim da fase:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.dt_str_end"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="01/01/2001"
                        @change="prepareAndReturn()"
                    />
                    <!-- :placeholder="formLocal.minutos" -->
                </div>
            </div>

            <div class="linhaForm">
                <span class="tLinha">Hora de fim da fase:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.hhmm_end"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="00:01"
                        @change="prepareAndReturn()"
                    />
                    <!-- :placeholder="formLocal.minutos" -->
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { convHhmmToUtc } from "../auxSC/handleTimeConv.js"; // criado em 04/05/2026
import { convFromUtc } from "../auxSC/timeConv.js";

export default {

    props:['phase'],

    data() {
        return {
            // -- default form
            formLocal: {
                'dt_str_init':'01/01/2001',
                'hhmm_init':'05:01',
                'dt_str_end':'01/01/2001',
                'hhmm_end':'06:01'
            },
        }
    },

    methods:{

        prepareAndReturn() { 

            // -- validar form.

            // -- validação do formato.
            let flag_dtStr_ok = this.atualizarFormulario_dtStr('dt_str_init')
            if (!flag_dtStr_ok) { return }

            flag_dtStr_ok = this.atualizarFormulario_dtStr('dt_str_end')
            if (!flag_dtStr_ok) { return }

            let flag_hhmm_ok = this.atualizarFormulario_hhmm('hhmm_init')
            if (!flag_hhmm_ok) { return }

            flag_hhmm_ok = this.atualizarFormulario_hhmm('hhmm_end')
            if (!flag_hhmm_ok) { return }

            // -- converter horário local para utc nos dois formatos.
            const tzName = this.$store.state.fusoHorarioSC // esperado algo como --> "Europe/Lisbon"

            // -- converter string --> dt
            const hhmmUTC_init = convHhmmToUtc( // retorna --> hh:mm e dd/mm/aaaa
                this.formLocal['hhmm_init'], 
                tzName, 
                this.formLocal['dt_str_init']
            )
            const dt_str_init = `${this.formLocal['dt_str_init']}-${hhmmUTC_init}` // problema com dt na virada do dia ??
            const utc_dt_init = this.convStrToDt(dt_str_init) // string --> dt

            // -- converter string --> dt
            const dataStr_end = this.formLocal['dt_str_end']
            const hhmmLocal_end = this.formLocal['hhmm_end']
            const hhmmUTC_end = convHhmmToUtc(hhmmLocal_end, tzName, dataStr_end) // hh:mm e dd/mm/aaaa
            const dt_str_end = `${dataStr_end}-${hhmmUTC_end}` // problema com dt na virada do dia ??
            const utc_dt_end = this.convStrToDt(dt_str_end) // string --> dt

            let endForm = {
                'utc_phase_init':utc_dt_init, // utc
                'utc_phase_end':utc_dt_end, // utc
            }

            // -- emitir form.
            this.$emit('fromFormDate', endForm) // dict input_last_info
        },

        convStrToDt(dateHrUtc) {
            const [data, hora] = dateHrUtc.split("-");
            const [dia, mes, ano] = data.split("/").map(Number);
            const [hh, mm] = hora.split(":").map(Number);

            return new Date(Date.UTC(ano, mes - 1, dia, hh, mm));
        },

        atualizarFormulario_hhmm(key) {
            // -- verificação se está no formato correto.
            //const flag_fmt_hhmm_ok = this.validarHoraHhmm(this.formLocal['hhmm'])
            const flag_fmt_hhmm_ok = this.validarHoraHhmm(this.formLocal[key])
            if (flag_fmt_hhmm_ok) { 
                return true
            }
            else { 
                this.formLocal[key] = '05:02' // reset para o fmt correto
                return false
            }
        },

        atualizarFormulario_dtStr(key) {
            // -- verificação se está no formato correto.
            //const flag_fmt_dtStr_ok = this.validarDataDdMmAaaa(this.formLocal['dt_str'])
            const flag_fmt_dtStr_ok = this.validarDataDdMmAaaa(this.formLocal[key])
            if (flag_fmt_dtStr_ok) { 
                return true
            }
            else { 
                this.formLocal[key] = '01/01/2001' // reset para o fmt correto
                return false
            }
        },

        validarHoraHhmm(valor) {
            const regex = /^(\d{2}):(\d{2})$/;
            const match = valor.match(regex);

            if (!match) return false;

            const hora = parseInt(match[1], 10);
            const minuto = parseInt(match[2], 10);

            return (
                hora >= 0 &&
                hora <= 23 &&
                minuto >= 0 &&
                minuto <= 59
            );
        },

        validarDataDdMmAaaa(valor) {
            const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            const match = valor.match(regex);

            if (!match) return false;

            const dia = parseInt(match[1], 10);
            const mes = parseInt(match[2], 10);
            const ano = parseInt(match[3], 10);

            if (mes < 1 || mes > 12) return false;

            const dt = new Date(ano, mes - 1, dia);

            return (
                dt.getFullYear() === ano &&
                dt.getMonth() === mes - 1 &&
                dt.getDate() === dia
            );
        },

        prepareToExib(el) {

            const tzName = this.$store.state.fusoHorarioSC; // esperado --> "Europe/Lisbon"

            const init = convFromUtc(el['utc_phase_init'], tzName);
            el['dt_str_init'] = init.dataStr;
            el['hhmm_init'] = init.hhmm;

            const end = convFromUtc(el["utc_phase_end"], tzName);
            el['dt_str_end'] = end.dataStr;
            el['hhmm_end'] = end.hhmm;

            this.formLocal = el
        },
    },

    created() {
        //window.scrollTo(0,0)
        const phaseLocal = structuredClone(this.phase); // depth copy
        this.prepareToExib(phaseLocal)
    }
}
</script>
